import {decryptData, encryptData} from "./encr-decr";

/** INIZIO SEZIONE COSTANTI RELATIVE AL TOKEN E AI SUOI CAMPI */

/**
 * Costante che identifica il nome del token ricevuto alla login
 * @type {string}
 */
export const armoniaTokenName = 'TokenINWIT';

/**
 * Costante che identifica il nome del campo del token relativo ai ruoli
 * @type {string}
 */
export const tokenRolesField = 'roles';

/**
 * Costante che identifica il nome del campo del token relativo alla username
 * @type {string}
 */
export const tokenUsernameField = 'username';

/** INIZIO SEZIONE SESSIONE STORAGE */

/**
 * Metodo che salva nella Session Storage l'oggetto 'inputData' con la chiave 'key'
 * @param inputData
 * @param key
 */
export function sessionSaveData (inputData, key) {
    if (!!inputData && !!key) {
        let inputDataCrypted = encryptData(inputData);
        sessionStorage.setItem(key, inputDataCrypted);
    }
}

/**
 * Metodo che salva dalla Session Storage l'oggetto booleano 'inputData' con la chiave 'key'
 * @param inputData
 * @param key
 */
export function sessionSaveBooleanData (inputData, key) {
    if (!!inputData && !!key) {
        /** Il valore del booleano deve essere memorizzato come stringa */
        let inputDataCrypted = encryptData(inputData.toString());
        sessionStorage.setItem(key, inputDataCrypted);
    }
}

/**
 * Metodo che recupera dalla Session Storage l'oggetto che ha chiave 'key'
 * @param key
 */
export function sessionGetData (key) {
    if (key) {
        return decryptData(sessionStorage.getItem(key));
    }
}

/**
 * Metodo che recupera dalla Session Storage l'oggetto booleano che ha chiave 'key'
 * @param key
 */
export function sessionGetBooleanData (key) {
    if (key) {
        /** Il valore del booleano nello storage è momorizzato come stringa */
        const decryptedValue = decryptData(sessionStorage.getItem(key));
        return decryptedValue === 'true';
    }
}

/**
 * Metodo che recupera dalla Session Storage l'array che ha chiave 'key' e lo
 * restituisce sottoforma di stringa
 * @param key
 */
export function sessionGetArrayData (key) {
    if (key) {
        let decrData = decryptData(sessionStorage.getItem(key));
        if (decrData) {
            let rolesConverted = JSON.parse("[" + decrData + "]");
            const rolesArray = rolesConverted.toString().split(',');
            return rolesArray.toString();
        }
    }
}

/**
 * Metodo che recupera dalla Session Storage l'array che ha chiave 'key' e lo
 * restituisce sottoforma di array
 * @param key
 */
export function sessionGetArray (key) {
    if (key) {
        let decrData = decryptData(sessionStorage.getItem(key));
        if (decrData) {
            let rolesConverted = JSON.parse("[" + decrData + "]");
            const rolesArray = rolesConverted.toString().split(',');
            return rolesArray;
        }
    }
}

/**
 * Metodo che elimina dalla Session Storage l'oggetto che ha chiave 'key'
 * @param key
 */
export function sessionRemoveData (key) {
    if (key) {
        sessionStorage.removeItem(key);
    }
}

/**
 * Metodo che elimina dalla Session Storage tutti gli oggetti presenti
 */
export function sessionRemoveAllData () {
    sessionStorage.clear();
}

/** FINE SEZIONE SESSIONE STORAGE */

/** INIZIO SEZIONE TOKEN */

/**
 * Metodo che effettua il parse di un token e se presente tokenFieldKey ritorna il campo del
 * token identificato con la key, altrimenti ritorna tutto il token
 * @param token
 * @param tokenFieldKey
 * @returns {any|null}
 */
export function parseToken (token, tokenFieldKey = null){
    try {
        if (!!tokenFieldKey) {
            return JSON.parse(atob(token.split('.')[1]))[tokenFieldKey.toString()];
        } else {
            return JSON.parse(atob(token.split('.')[1]));
        }
    } catch (e) {
        return null;
    }
}

/**
 * Metodo che recupera il campo del token (fieldKey) memorizzato nella session storage
 * @param fieldKey
 * @returns {*}
 */
export function getTokenField(fieldKey) {

    switch (fieldKey) {
        case 'roles':
            return sessionGetArray(fieldKey);

        case 'username':
            return sessionGetData(fieldKey)
    }

    // return sessionGetArrayData('roles');
}

/**
 * Metodo che recupera l'array dei ruoli del token (fieldKey) memorizzato nella session storage
 * e lo restituisce con il formato di un array
 * @param fieldKey
 * @returns {*}
 */
export function getRolesArray(fieldKey) {
    return sessionGetArray(fieldKey);
}

/** FINE SEZIONE TOKEN */
